<template>
    <div id="blog-post" class="page-content">
        <div class="container">
            <div class="heading">
                <h1>{{ post.title }}</h1>
                <p class="post-date">
                    {{ $moment(post.published_at).format('DD MMM YYYY') }}
                </p>
            </div>
        </div>
        <div class="full-width marginT">
            <div class="container " :style="{ position: 'relative' }">
                <div
                    :style="{
                        backgroundImage: 'url(' + appUrl + post.image + ')'
                    }"
                    class="post-img lazyload"
                />
            </div>
        </div>

        <div class="container marginT">
            <div v-html="post.content" />
        </div>

        <div class="blog-nav">
            <div class="container">
                <nuxt-link to="/blog">Back to all posts</nuxt-link>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
    async asyncData({ app, store, error }) {
        await store
            .dispatch('general/getBlogPost', app.context.params.post_slug)
            .catch((e) => {
                error({
                    statusCode: e.response.status,
                    message: 'Page not found'
                })
            })
    },

    head() {
        return {
            title: this.post.title,
            meta: [
                {
                    hid: 'title',
                    name: 'title',
                    content: this.post.title
                },
                {
                    hid: 'description',
                    name: 'description',
                    content: this.post.meta_description
                }
            ]
        }
    },

    computed: {
        ...mapGetters({
            post: 'general/post'
        }),

        appUrl() {
            return process.env.appUrl
        }
    },

    methods: {
        moment() {
            return moment()
        }
    }
}
</script>

<style lang="scss" scoped>
.full-width {
    display: inline-block;
    width: 100%;
    background: #e7f7ef;

    .container {
        padding-top: 7em;
        padding-bottom: 4em;
    }

    h1,
    h4 {
        padding-right: 7em;
    }
}

#blog-post {
    .container {
        max-width: 800px;
    }
}

.post-date {
    color: $body-light;
}

.post-img {
    position: absolute;
    bottom: -2em;
    width: 300px;
    height: 300px;
    background-size: cover;
    background-position: center center;
    border-radius: 4px;
    -webkit-box-shadow: 0px 0px 21px 0px rgba(0, 0, 0, 0.25);
    -moz-box-shadow: 0px 0px 21px 0px rgba(0, 0, 0, 0.25);
    box-shadow: 0px 0px 21px 0px rgba(0, 0, 0, 0.25);
}

.blog-nav {
    margin: 2em 0;
    padding: 2em 0;
    text-align: center;
    border-top: 1px solid $linen;
    border-bottom: 1px solid $linen;

    a {
        border-bottom: 1px solid;
    }

    .el-button {
        margin-left: 2em;
    }
}

@media only screen and (max-width: 1199px) {
    .full-width {
        .container {
            padding-top: 12em;
            padding-bottom: 2em;
        }

        h1,
        h4 {
            padding-right: 10em;
        }
    }
}

@media only screen and (max-width: 767px) {
    .full-width {
        h1,
        h4 {
            padding-right: 0;
            margin: 0.5em 0;
        }
    }

    .blog-nav {
        a {
            display: table;
            margin: 0 auto;
        }

        .el-button {
            display: table;
            margin: 1em auto 0 auto;
        }
    }
}
</style>
